import type {Numberish} from '../types/CommonTypes'

export const normalizeInput = (
  v: Numberish | null,
  modelModifiers: Record<'number' | 'lazy' | 'trim', true | undefined>
) => {
  if (v === null) return
  let update = v
  if (modelModifiers.number && typeof update === 'string' && update !== '') {
    const parsed = Number.parseFloat(update)
    update = Number.isNaN(parsed) ? update : parsed
  }
  return update
}
